import { render, staticRenderFns } from "./HonorSystem_Rank_Year.vue?vue&type=template&id=61949f3b&"
import script from "./HonorSystem_Rank_Year.vue?vue&type=script&lang=js&"
export * from "./HonorSystem_Rank_Year.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports